import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from '@services/seo.service';

@Component({
    selector: 'app-politicas',
    templateUrl: './politicas.component.html',
    styleUrls: ['./politicas.component.css'],
    standalone: false
})
export class PoliticasComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private seo: SeoService
  ) {
    if (isPlatformBrowser(this.platformId)) window.scrollTo(0, 0);
   }

  ngOnInit(): void {
    this.seo.update({
      title: 'Politicas de envio | Clave Winds',
      description: 'Consulta las politicas de envio, entrega y condiciones para compras en Clave Winds.',
      canonical: this.seo.absoluteUrl('/politicas')
    });
  }

}
